  <template>
    <div>
        <br>
        <hr>
            <form id="form_actes"  method="post" :action="'/convs/'+conv.ref" role="form" enctype="multipart/form-data">
                <input type="hidden" name="_token" :value="csrfToken" >
                <input type="hidden" name="ref" id="ref" :value="conv">
                <input type="hidden" name="convTitle" id="convTitle" :value="conv.title">
                <input type="hidden" name="convRef" id="convRef" :value="conv.ref">
                <meta name="csrf-token" :content="csrfToken">
                <div class="form-group row">
                    <div class="col">
                        <h5>Je suis :</h5>
                        <b-form-select v-model="type_user" :options="options_user" :required="true" class="" id="type_utilisateur" name="type_utilisateur" aria-describedby="type_utilisateur"></b-form-select>
                    </div>
                </div>
                <div class="form-group row" v-if="(type_user != 'collectiv' && type_user != 'presta') ">
                    <div class="col">
                        <h5>Objet de la demande :</h5>
                        <b-form-select v-model="type_demande" :options="options_demande" :required="true" class="" id="selectedDemandeObject" name="selectedDemandeObject" aria-describedby="type_demande"></b-form-select>
                    </div>
                </div>
              <!-- patch pour suppression des actes d'engagements  = test 1+1==3   --->
               <!--  <div v-if="1+1==3 && type_user != null && type_demande != null && conv.slug != 'ref_parc_priv_dom'">
                    <br>
                <h4 class="text-primary"><i class="fa fa-cloud-download text-primary" aria-hidden="true" ></i> Télécharger les actes d'engagement : </h4>
                    <br>
                    <div class="text-center">
                        <div class="alert alert-primary2" role="alert">
                            <i class="fa fa-2x fa-info-circle" aria-hidden="true"></i><br>
                            <p v-if="type_user == 'autre_dtt_dreal' && type_demande=='acces_etat' && conv.ref=='pppi'">Vous devez remplir, imprimer, signer et faire signer par le responsable de la structure les documents suivants :</p>
                            <p v-else >Vous devez remplir, imprimer et signer le document suivant :</p>
                            <p class="text-primary" v-if="type_demande == 'acces_etat'">
                                <a  v-for="acte, index in actes" target="_blank"  :href="'/storage/annexes/'+acte.slug+'.'+acte.type" class="list-group-item list-group-item-action" v-if="(acte.slug).indexOf('ae-utilisateur')>=0">
                                    <span class=""></span><i class="fa fa-download" aria-hidden="true"></i> <span class="text-primary">{{acte.short_title}}</span> ({{acte.type}})
                                </a>
                            </p>
                            <p class="text-primary" v-if="type_user == 'autre_dtt_dreal' && type_demande=='acces_etat'">
                                <a  v-for="acte, index in actes" target="_blank"  :href="'/storage/annexes/'+acte.slug+'.'+acte.type" class="list-group-item list-group-item-action" v-if="(acte.slug).indexOf('designation-utilisateur')>=0">
                                    <span class=""></span><i class="fa fa-download" aria-hidden="true"></i> <span class="text-primary">{{acte.short_title}}</span> ({{acte.type}})
                                </a>
                            </p>
                            <p class="text-primary" v-if="type_demande == 'extract_collectivite'">
                                <a  v-for="acte, index in actes" target="_blank"  :href="'/storage/annexes/'+acte.slug+'.'+acte.type" class="list-group-item list-group-item-action" v-if="(acte.slug).indexOf('ae-collective')>=0">
                                    <span class=""></span><i class="fa fa-download" aria-hidden="true"></i> <span class="text-primary">{{acte.short_title}}</span> ({{acte.type}})
                                </a>
                            </p>
                            <p class="text-primary" v-if="type_demande == 'extract_be'">
                                <a  v-for="acte, index in actes" target="_blank"  :href="'/storage/annexes/'+acte.slug+'.'+acte.type" class="list-group-item list-group-item-action" v-if="(acte.slug).indexOf('ae-be')>=0">
                                    <span class=""></span><i class="fa fa-download" aria-hidden="true"></i> <span class="text-primary">{{acte.short_title}}</span> ({{acte.type}})
                                </a>
                            </p>

                            <p v-if="type_user == 'autre_dtt_dreal' && type_demande=='acces_etat' && conv.ref=='pppi'"  >Une fois signés, ces documents peuvent être scannés et soumis dans le formulaire accessible ci-dessous.</p>
                            <p v-else>Une fois signé, ce document peut être scanné et soumis dans le formulaire accessible ci-dessous.</p>
                        </div>
                    </div>

                      <br>
                     
                      <div class="alert alert-taupe2 mt-2" v-if="conv.ref=='pp'">
                        <i class="fa fa-info-circle text-primary2" aria-hidden="true"></i><span class="font-weight-bold  "> Attention, pour chaque outil, un nombre limité d'utilisateurs par territoire est autorisé :</span>
                        <br>
                        <span class="font-weight-bold">Pour les synthèses Parc privé :</span>
                        <br>
                        <span class="font-weight-bold">DREAL :</span> 2 utilisateurs en charge de l'activité de l'Anah, 1 statisticien régional, 1 autre utilisateur
                        <br>
                        <span class="font-weight-bold">DDT :</span> 2 utilisateurs en charge de l’activité de l'Anah, 1 autre utilisateur
                      </div>
                      
                      <div class="alert alert-taupe2 mt-2" v-if="conv.ref=='pppi'">
                        <i class="fa fa-info-circle text-primary2" aria-hidden="true"></i><span class="font-weight-bold "> Attention, pour chaque outil, un nombre limité d'utilisateurs par territoire est autorisé :</span>
                        <br>
                        <span class="font-weight-bold">Pour le Parc Privé Potentiellement Indigne (PPPI) :</span>
                        <br>
                        <span class="font-weight-bold">DREAL :</span> 1 utilisateur en charge de l'activité de l'Anah, 1 statisticien régional, 1 autre utilisateur
                        <br>
                        <span class="font-weight-bold">DDT :</span> 2 utilisateurs en charge de l’activité de l'Anah, 1 autre utilisateur
                      </div>
                      
                      <div class="alert alert-taupe2 mt-2" v-if="conv.ref=='copro'">
                        <i class="fa fa-info-circle text-primary2" aria-hidden="true"></i><span class="font-weight-bold  "> Attention, pour chaque outil, un nombre limité d'utilisateurs par territoire est autorisé :</span>
                        <br>
                        <span class="font-weight-bold">Pour le fichier de repérage des copropriétés fragiles :</span>
                        <br>
                        <span class="font-weight-bold">DREAL :</span> tous les référents en charge de l'activité de l'Anah, 3 autres utilisateurs
                        <br>
                        <span class="font-weight-bold">DDT :</span> tous les référents en charge de l’activité de l'Anah, 3 autres utilisateurs
                      </div>
                </div> -->
                <br>
                <div class="text-center">
                            <!-- <b-button  variant="primary" @click="toggleForme()" v-if="type_user != null && type_demande != null">Formulaire</b-button>-->
                </div>
                    <div v-if="type_user=='collectiv'" class="text-center">
                        <div class="text-center text-primary margin-b-8">
                            <svg xmlns="http://www.w3.org/2000/svg" style="width:45px;" viewBox="0 0 640 640" ><path fill="currentColor" d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/></svg>
                        </div>
                        <p class="font-weight-bold">
                            Vous êtes une collectivité territoriale ou un établissement public de coopération intercommunale.
                        </p>
                        <p class="font-weight-bold">
                            Seules des données extraites peuvent vous être transmises.
                        </p>
                        <p>
                            Pour en obtenir sur votre territoire d'étude, vous devez passer par un service de l'État avec lequel vous avez un cadre partenarial dans le cadre de votre étude (Par exemple : PLU, PLH, PDH, OPAH, PIG, Pactes Territoriaux, documents de planification ou de programmation, etc.).<br/>
                            Ce service sera votre interlocuteur pour la demande  et vous enverra les données correspondant à votre périmètre d'étude, après qu'il ait complété un formulaire d'engagement  pour la demande d'extraction aux collectivités.<br/>   
                            Si vous êtes maître d'ouvrage et que l'étude est confiée à un prestataire, deux formulaires devront alors être renseignés : l'un pour vous, l'autre à destination de votre prestataire.<br/>
                         </p>
                         <p>
                            Tous les destinataires s'engagent à utiliser les données dans le respect des conditions prévues, en prenant bien connaissance des méthodologies et des précautions d'usage et d'interprétation.
                        </p>
                    </div>
                    <div v-if="type_user=='presta'" class="text-center">
                        <div class="text-center text-primary margin-b-8">
                            <svg xmlns="http://www.w3.org/2000/svg" style="width:45px;" viewBox="0 0 640 640" ><path fill="currentColor" d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/></svg>
                        </div>
                        <p class="font-weight-bold">
                            Vous êtes prestataire d'études.
                        </p>
                        <p class="font-weight-bold">
                            Seules des données extraites peuvent vous être transmises.
                        </p>
                        <p>
                            Pour en faire la demande, vous devez vous rapprocher du maître d'ouvrage de votre étude, sous réserve du respect des conditions d'utilisation.
                              
                        </p>
                        <p class="font-weight-bold">
                            Le maître d'ouvrage peut être :
                        </p>
                        <ul>
                            <li>
                                <span class="font-weight-bold">Une collectivité :</span> La collectivité s'adresse au service de l'état avec lequel elle dispose d'un partenariat contractualisé pour l'étude concernée (Par exemple : PLU,PLH,PDH, OPAH, PIG, Pactes Territoriaux, documents de planification ou programmation,etc.). 
                                <br>
                                <br>Ce service vous transmettra les données correspondant au périmètre d'étude, après avoir rempli deux formulaires d'engagement : l'un pour la collectivité maitre d'ouvrage et l'autre pour vous.
                                <br>
                                <br>
                            </li>
                            <li>
                                <span class="font-weight-bold">Un service de l'état : </span>Le service peut directement remplir un formulaire à votre nom et vous envoyer l'extraction correspondante.
                            </li>
                        </ul>
                         <p>
                            Tous les destinataires s'engagent à utiliser les données dans le respect des conditions prévues, en prenant bien connaissance des méthodologies et des précautions d'usage et d'interprétation.
                        </p>
                    </div>
                  <div id="form_inputs" v-if=" display_form && type_user != 'presta' && type_user != 'collectiv'" class="text-left">
                      <p class="alert-info p-3 text-center">Merci de bien vouloir renseigner ces informations :</p>
                      <hr>
                      <div class="form-group"> données  :
                          <br>
                          <label for="structure_name">Raison sociale </label>
                          <input type="text" class="form-control" id="structure_name" name="structure_name" aria-describedby="srtructure_name" placeholder="Précisez..." required>
                      </div>

                      <div class="form-group row">
                                  <div class="col">
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="sex"  value="h" checked>
                                          Monsieur
                                      </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                      <label class="form-check-label">
                                          <input class="form-check-input" type="radio" name="sex"  value="F">
                                                 Madame
                                      </label>
                                  </div></div>
                      </div>
                      <div class="form-group row">
                          <div class="col">
                              <input type="text" class="form-control" id="forname" name="forname" placeholder="Prénom" required>
                          </div>
                          <div class="col">
                              <input type="text" class="form-control" id="name" name="name" placeholder="Nom" required>
                          </div>
                      </div>
                      <div class="form-group">
                        <label for="email">Adresse mail  </label>
                        <input type="email" class="form-control" id="email" name="email" aria-describedby="emailHelp" placeholder="adresse mail" required>
                        <small id="emailHelp" class="form-text text-muted">Ce mail servira de contact administratif</small>
                      </div>
                      <div class="form-group">
                          <input type="texte" class="form-control" id="fonction" name="fonction" aria-describedby="fonctionHelp" placeholder="Fonction" required>
                      </div>
                      <div class="form-group">
                          <input type="texte" class="form-control" id="service" name="service" aria-describedby="servicenHelp" placeholder="Service" >
                      </div>

                      <div class="form-group">
                          <b-form-select v-model="type_etude" :options="options_type" :required="true" class="" id="type_etude" name="type_etude" aria-describedby="type_etude"></b-form-select>
                      </div>
                      <div class="form-group mb-3">
                          <input type="texte" class="form-control" id="title_etude" name="title_etude" aria-describedby="title_etude" placeholder="Préciser le titre de l'étude..." >
                      </div>
                      <br>
                      <div class="form-group  p-2" v-if="conv.ref != 'ppdom' && 1+1==3">
                          <input type="file" id="file" name="file" class="file">
                          <div class="input-group col-xs-12">
                              <span class="input-group-addon"><i class="fa fa-file-text-o" aria-hidden="true"></i></span>
                              <input type="text" class="form-control input-lg" disabled placeholder="Pas de fichier actuellement selectionné" required>
                              <span class="input-group-btn">
                                  <button class="browse btn btn-primary input-lg" type="button"><i class="glyphicon glyphicon-search"></i> Choisir un fichier à transmettre</button>
                              </span>
                              <br>
                          </div>
                          <br>
                          <button  class="btn btn-outline-grisBleuClaire btn-sm" @click=" display_file2 = ! display_file2 " >Ajouter un document supplémentaire
                               <i class="fa fa-plus-square text-secondary" aria-hidden="true" v-if="!display_file2"></i>
                               <i class="fa fa-minus-square text-secondary" aria-hidden="true" v-if="display_file2"></i>
                          </button>
                      </div>
                      <div  class="form-group  p-2" v-if="conv.ref != 'ppdom' && display_file2 && 1+1==3">
                          <input type="file" id="file2" name="file2" class="file2">
                          <div class="input-group col-xs-12">
                              <span class="input-group-addon"><i class="fa fa-file-text-o" aria-hidden="true"></i></span>
                              <input type="text" class="form-control input-lg" disabled placeholder="Pas de fichier actuellement selectionné">
                              <span class="input-group-btn">
                                  <button class="browse btn btn-primary input-lg" type="button"><i class="glyphicon glyphicon-search"></i> Choisir un fichier à transmettre</button>
                              </span>
                          </div>
                      </div>
                      <br>
                    <div v-if="type_demande=='acces_etat'" class="form-check text-left">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" required>
                        Je reconnais avoir pris connaissance <a href="/storage/annexes/modalites-utilisation-outils-plateforme.pdf" target="_blank">des conditions générales d’utilisation</a> des outils de connaissance du parc privé
                      </label>
                    </div>
                     <div   class="form-check text-left" v-if="type_user != 'autre_dtt_dreal' && type_demande!='acces_etat'">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" required>
                        Je m’engage à transmettre les conditions générales d'utilisation des outils de connaissance du parc privé dont je vais fournir des extractions, ainsi que la notice méthodologique associée à l’outil en téléchargement dans la rubrique
                        <a href="/pprive_doc/1" v-if="conv.ref == 'pp'" target="_blank">« Zone documentaire »</a>
                        <a href="/pppi_doc/1" v-else-if="conv.ref == 'pppi'" target="_blank">« Zone documentaire »</a>
                        <a href="/copro_doc/1" v-else-if="conv.ref == 'copro'" target="_blank">« Zone documentaire »</a>
                        <span v-else>« Zone documentaire »</span>
                      </label>
                    </div> 
                      <br>
                      <button  type="submit" class="btn btn-primary">Envoyer</button>
                  </div><!-- end hidden input -->
            </form>
    </div>
</template>
<script>

    import moment from 'moment';
    import Swal from 'sweetalert2';

    export default {
        name: "acte_engagement_forme",
        props: ['conv', 'structure_type', 'actes', 'user_category', 'popup_conges'],
        data(){
            return{
                csrfToken : null,
                display_form: false,
                display_file2: false,
                upFile:null,
                nb_acte : 0,
                type_etude: null,
                type_demande: null,
                type_user: null,
                options_user: [
                   { value: null, text: 'Merci de sélectionner votre statut...'},
                   //{ value: 'anah_dtt_dreal', text: 'En charge de l’activité de l’Anah DDT ou DREAL'},
                   //{ value: '  statiticien_dreal', text: 'Statisticien régional DREAL'},
                   //{ value: 'autre_dtt_dreal', text: 'Autre cas : DDT, DREAL, Ministère...'},
                ],
                options_demande: [
                    { value: null, text: 'Merci de sélectionner l\'objet de la demande ...'},
                    { value: 'acces_etat', text: 'Demande d\'accès utilisateur État'},
                    { value: 'extract_collectivite', text: 'Transmission d\'extractions Collectivité'},
                    { value: 'extract_be', text: 'Transmission d\'extractions Bureau d\'études'},
                ],
                options_type:    [
                        { value: null, text: 'Merci de choisir l\'objet de l\'étude...'},
                        { value: 'definition_politique_locale', text: 'Aide à la définition des politiques locales de l\'habitat' },
                        { value: 'programmmation_logement social', text: 'Aide à la programmation du logement social' },
                        { value: 'observation_politiques_local', text: 'Aide à l\'observation et à la mise en oeuvre des politiques locales de l\'habitat' },
                        { value: 'evaluation_politiques_publiques', text: 'Évaluation des politiques publiques' },
                    ],
            }
        },
        watch: {
          type_etude: function(val){
            (val != null && this.type_demande != null)?this.display_form=true:this.display_form=false;
          },
          type_demande: function(val){
            (val != null && this.type_demande != null)?this.display_form=true:this.display_form=false;
          }
        },
        mounted(){

            this.csrfToken = csrfToken;

            this.prepareComp();


            if(this.conv.ref=='ppdom'){
                this.options_type.push({ value: 'etude_autre', text: 'Autre' });
                this.display_form=true
            }



            //console.log(this.actes);

            //(this.conv.ref=='ppdom')?this.display_form=true:null;

            $(document).on('click', '.browse', function(){
                var file = $(this).parent().parent().parent().find('.file');
                file.trigger('click');
            });

            $(document).on('click', '.browse', function(){
                var file = $(this).parent().parent().parent().find('.file2');
                file.trigger('click');
            });

            $(document).on('change', '.file',(msg)=>{
                console.log(msg.currentTarget.files[0]);
            });

            $(document).on('change', '.file', function(){
                $(this).parent().find('.form-control').val($(this).val().replace(/C:\\fakepath\\/i, ''));
            });

            $(document).on('change', '.file2', function(){
                $(this).parent().find('.form-control').val($(this).val().replace(/C:\\fakepath\\/i, ''));
            });
        },
        methods:{
            prepareComp:function(){

              ////// TEMPO : POPUP/MESSAGE ABSENCE RÉPONSE RAPIDE DURANT LA PERIODE

              let popup_start_at = (this.popup_conges)?this.popup_conges.start_at:'19990101';
              let popup_end_at = (this.popup_conges)?this.popup_conges.end_at:'19990102';

              moment.locale('fr');

              (moment().isBetween(popup_start_at, popup_end_at))
                  ?Swal.fire({
                    title: 'Information',
                    html: '<span >Attention</span>, votre demande d\'accès ne pourra être traitée qu\'à compter du <span class="text-primary"> '+moment(popup_end_at).format('LL')+'</span>. <br><br/>Merci de votre compréhension.',
                    icon:'info',
                    confirmButtonText: 'Continuer'
                  }
                  ) :null;

              //////////   FIN TEMPO

              //console.log(this.user_category);
                for(let i = 0; i<this.user_category.length; i++){
                    this.options_user.push({value: this.user_category[i].name, text:this.user_category[i].label });
                }
            },
            submitQuerry: function(evt){
                //console.log('go');
            },
            getActesEngag: function(){
            },
            toggleForme: function(){
                (this.display_form==true)? this.display_form=false:this.display_form=true;
            }
        }
    }
</script>

<style scoped>

        .file{
            visibility: hidden;
            position: absolute;
        }

        .file2{
            visibility: hidden;
            position: absolute;
        }

</style>